import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Construction } from "lucide-react";

export function UnderConstructionDialog({ open, onOpenChange, featureName }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm text-center">
        <DialogHeader className="items-center">
          <div className="mx-auto mb-2 p-4 rounded-full bg-amber-500/10">
            <Construction className="h-10 w-10 text-amber-500" />
          </div>
          <DialogTitle>Under Construction</DialogTitle>
          <DialogDescription>
            <strong>{featureName}</strong> is currently being built and will be available soon. Stay tuned for updates!
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="justify-center sm:justify-center">
          <Button onClick={() => onOpenChange(false)} data-testid="under-construction-close">
            Got it
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
